import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { Button, Grid, TextField } from '@mui/material';
import { Box } from '@mui/system';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getEmirates } from '../../../utils/constants';
import firebase from "firebase/app";
import { useHistory } from 'react-router-dom';
import { SignInWithFacebook, SignInWithGoogle } from '../../../utils/firebase';
import { useTranslation } from "react-i18next";
import { registerValidation } from "../../../validators/register";
import CountryPicker from "../../../components/pickers/CountryPicker";
import PhoneInput from "react-phone-input-2";
import "../../../components/bootstrap.css";
import { isMobile } from "react-device-detect";
const EmailRegister = () => {
    const genders = ["Male", "Female"];
    const [gender, setGender] = React.useState('male');
    const emarites = getEmirates();
    const [emarite, setEmarite] = React.useState(null);
    const history = useHistory();
    const handleChange = (event) => {
        setEmarite(event.target.value);
    };
    const { t, i18n } = useTranslation();
    // Handle Facebook Login
    const loginWithFacebook = () => {
        history.push("/register?auth=facebook");
        try {
            SignInWithFacebook()
                .then(() => { history.push("/") })
                .catch((err) => {
                    let errorMessage = err.message;
                    console.log(errorMessage);
                    // setError(errorMessage);
                });
        } catch (e) {
            let errorMessage = e.message;
            console.log(errorMessage);
            // setError(errorMessage);
        }
    };
    // Handle Google Sign In
    const loginWithGoogle = () => {
        history.push("/register?auth=google");
        try {
            SignInWithGoogle()
                .then(() => { history.push("/") })
                .catch((err) => {
                    let errorMessage = err.message;
                    // setError(errorMessage);
                });
        } catch (e) {
            let errorMessage = e.message;
            // setError(errorMessage);
        }
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            Copassword: '',
            phone: '',
            name: '',
            birthDate: '',
            gender: '',
            nationality: '',


        },
      validateOnChange:true,
        onSubmit: (values) => {
            firebase.auth().createUserWithEmailAndPassword(values.email, values.password)
                .then(async (result) => {
                    await firebase.firestore().collection('users').doc(result.user.uid).set({
                        email: values.email,
                        fullName: values.name,
                        id: result.user.uid,
                        phone: values.phone,
                        birthDate: new Date(values.birthDate),
                        nationality: values.nationality,
                        gender: values.gender,
                        accessType: 'email'
                    });
                    console.log("user successfully saved")
                }).then(() => {
                    history.push("/");
                })
                .catch(err => {
                    console.log("Register Error : ", err.message);
                });
        },
        validationSchema: registerValidation,

    })
    return (
        <div className='formContainer'>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center",flexDirection: isMobile ? "column" : "row"  }}
                
                autoComplete="off">
                <TextField
                    id="outlined-email"
                    label="Email"
                    variant="outlined"
                    type={'email'}
                    className='formInput'
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    helperText={formik.errors.email}
                    error={!!formik.errors.email}
                />
                <TextField
                    id="outlined-password"
                    label="Password"
                    type={'password'}
                    variant="outlined"
                    className='formInput'
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    helperText={formik.errors.password}
                    error={!!formik.errors.password}
                />
            </Box>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: isMobile ? "column" : "row" }}
                noValidate
                autoComplete="off">
                <TextField
                    style={{ marginInline: "0.5ch", minWidth: '25ch', }}
                    id="outlined-password"
                    label="Confirm Password"
                    type={'password'}
                    variant="outlined"
                    className='formInput'
                    name="Copassword"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.Copassword}
                    helperText={formik.errors.Copassword}
                    error={!!formik.errors.Copassword}
                />

                <PhoneInput
                    country={"ae"}
                    enableSearch={true}
                    specialLabel="Phone Number"
                    inputStyle={{ marginInline: ".5ch", minWidth: '25ch', "-webkit-tap-highlight-color": "transparent", backgroundColor: "transparent", "-webkit-tap-highlight-color": "transparent", }}
                    containerStyle={{ marginInline: "1ch", backgroundColor: "transparent", "-webkit-tap-highlight-color": "transparent", minWidth: '25ch' }}
                    value={formik.values.phone}
                    isValid={!formik.errors?.phone}
                    defaultErrorMessage={formik.errors.phone}
                    enableAreaCodes
                    countryCodeEditable={false}
                    onBlur={formik.handleBlur}
                    inputProps={{
                        id: "outlined-pnone",
                    }}
                    onChange={(val) => {
                       
                        formik.setFieldValue("phone", val)
                    }}
                />
            </Box>

            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center" ,flexDirection: isMobile ? "column" : "row" }}
                noValidate
                autoComplete="off">
                <TextField
                    id="outlined-password"
                    label="Full Name"
                    type={'text'}
                    variant="outlined"
                    className='formInput'
                    name="name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    helperText={formik.errors.name}
                    error={!!formik.errors.name}
                />
                <TextField
                    name="birthDate"
                    label="Birth Date"
                    InputLabelProps={{ shrink: true, required: true }}
                    type="date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.birthDate}
                />
            </Box>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center",flexDirection: isMobile ? "column" : "row"  }}
                noValidate
                autoComplete="off">
                <FormControl style={{ width: "55%" }}>
                    <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="gender"
                        onChange={(event)=>{formik.setFieldValue("gender",event.target.value)}}
                        value={formik.values.gender}
                    >
                        {genders.map((g) => (
                            <MenuItem value={g}>{g}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <div style={{ height: "20px" }} />
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '30ch', },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center",flexDirection: isMobile ? "column" : "row"  }}
                noValidate
                autoComplete="off">
                <FormControl style={{ width: "55%" }}>
                    <InputLabel id="demo-simple-select-label">{t('users.nationality')}</InputLabel>
                    <CountryPicker
                        onChange={(e) => {
                            formik.setFieldValue("nationality", e.target.value)
                        }}
                        value={formik.values.nationality}
                        label={t('users.nationality')}
                        name="nationality" labelId="demo-simple-select-label" id="demo-simple-select-label" />
                </FormControl>
            </Box>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '30ch' },
                }}
                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                noValidate
                autoComplete="off">
                <Button className='submitBtn' style={{ width: "50%" }} onClick={formik.handleSubmit} disabled={!formik.isValid || formik.isSubmitting || formik.isValidating} variant="contained">Sign Up</Button>
            </Box>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "25px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div onClick={loginWithFacebook} >
                        <img src="https://img.icons8.com/color/96/null/facebook-new.png" alt={'facebook'} style={{ height: "30px", width: "30px" }} />
                    </div>
                    <div onClick={loginWithGoogle}>
                        <img src="https://img.icons8.com/color/96/null/google-logo.png" alt={'google'} style={{ height: "30px", width: "30px" }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailRegister;